// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileContent_container__7R8_J","data_point":"ProfileContent_data_point__T0aq9"};